import { motion } from 'framer-motion';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Gift, Coffee, Users } from 'lucide-react';

export const EventCards = () => {
  const events = [
    {
      id: 'santa-toys-for-tots',
      icon: Gift,
      title: 'Santa + Toys for Tots',
      description: 'Family-friendly event supporting local kids. Bring your little ones!',
      eventUrl: 'https://events.kgob.com/santa-toys-for-tots-2025',
      buttonText: 'RSVP Now'
    },
    {
      id: 'free-coffee-fridays',
      icon: Coffee,
      title: 'Free Coffee Fridays',
      description: 'Drop by any KGOB office for a cup on us. No appointment needed.',
      eventUrl: 'https://events.kgob.com/free-coffee-fridays',
      buttonText: 'RSVP Now'
    },
    {
      id: 'networking-breakfasts',
      icon: Users,
      title: 'Monthly Networking Breakfasts',
      description: 'Meet local business owners and professionals over breakfast.',
      eventUrl: 'https://events.kgob.com/networking-breakfast',
      buttonText: 'RSVP Now'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {events.map((event, index) => {
        const Icon = event.icon;
        return (
          <motion.div
            key={event.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
          >
            <Card className="p-6 h-full flex flex-col rounded-2xl border-[#E1DFD7] bg-white hover:shadow-lg transition-all duration-300">
              <div className="flex items-center justify-center w-14 h-14 rounded-xl bg-[#D4AF37]/10 border border-[#D4AF37]/20 mb-4 mx-auto">
                <Icon className="w-7 h-7 text-[#D4AF37]" />
              </div>
              
              <h3 className="font-['Playfair_Display'] text-xl font-semibold text-[#0B2240] mb-3 text-center">
                {event.title}
              </h3>
              
              <p className="text-sm text-[#4C5A70] leading-relaxed mb-6 text-center flex-1">
                {event.description}
              </p>
              
              <Button
                asChild
                className="w-full rounded-xl bg-[linear-gradient(180deg,#E8D89E_0%,#D4AF37_50%,#B99610_100%)] text-[#0B2240] hover:brightness-95 shadow-[inset_0_1px_0_rgba(255,255,255,0.35)] font-medium"
                data-testid={`rsvp-${event.id}`}
              >
                <a data-testid="event-cards-a-1" href={event.eventUrl} target="_blank" rel="noopener noreferrer">
                  {event.buttonText}
                </a>
              </Button>
            </Card>
          </motion.div>
        );
      })}
    </div>
  );
};
